import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { FileDropzone, UploadingFileList } from './components';
import { useUploadFiles } from './upload-files.hook';
import { Spin } from 'antd';
import { isFileExtensionAllowed, isFileSizeWithinLimit } from '../../config/ai-chat-file-constraints';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "upload-filescontainer__Container",
  componentId: "sc-19m9npz-0"
})(["display:flex;flex-direction:column;height:100%;"]);
var ErrorMessage = styled.div.withConfig({
  displayName: "upload-filescontainer__ErrorMessage",
  componentId: "sc-19m9npz-1"
})(["color:#ff4d4f;font-size:12px;margin-top:8px;text-align:center;"]);
var LoadingOverlay = styled.div.withConfig({
  displayName: "upload-filescontainer__LoadingOverlay",
  componentId: "sc-19m9npz-2"
})(["display:flex;align-items:center;justify-content:center;padding:40px 20px;border:2px dashed #d1d5db;border-radius:8px;background-color:#f9fafb;min-height:120px;flex-direction:column;gap:12px;"]);
var LoadingText = styled.div.withConfig({
  displayName: "upload-filescontainer__LoadingText",
  componentId: "sc-19m9npz-3"
})(["color:#6b7280;font-size:14px;font-weight:500;"]);
export var UploadFilesContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var maxFileUpload = _ref.maxFileUpload,
      allowedFileTypes = _ref.allowedFileTypes,
      fileSizeLimitMb = _ref.fileSizeLimitMb,
      totalSizeLimitMb = _ref.totalSizeLimitMb,
      disabled = _ref.disabled,
      hideUploadArea = _ref.hideUploadArea,
      fileSelector = _ref.fileSelector,
      onStateChange = _ref.onStateChange;
  var uploadHook = useUploadFiles(maxFileUpload, totalSizeLimitMb);

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  useImperativeHandle(ref, function () {
    return {
      getFiles: function getFiles() {
        return [];
      },
      clear: function clear() {
        uploadHook.clearFiles();
        setError(null);
      },
      uploadFiles: function () {
        var _uploadFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var uploadedItems;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return uploadHook.uploadFiles();

                case 3:
                  uploadedItems = _context.sent;
                  return _context.abrupt("return", uploadedItems);

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  setError('Upload failed. Please try again.');
                  throw _context.t0;

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        function uploadFiles() {
          return _uploadFiles.apply(this, arguments);
        }

        return uploadFiles;
      }(),
      isUploading: uploadHook.isUploading,
      hasUploadedFiles: uploadHook.hasUploadedFiles,
      isValidating: uploadHook.isValidating || !!uploadHook.validatingUrl
    };
  }, [uploadHook, uploadHook.isUploading, uploadHook.hasUploadedFiles, uploadHook.isValidating, setError]);

  var handleFilesSelected = function handleFilesSelected(files) {
    setError(null);
    var unsupportedFile = files.find(function (file) {
      return !isFileExtensionAllowed(file.name, allowedFileTypes !== null && allowedFileTypes !== void 0 ? allowedFileTypes : []);
    });

    if (unsupportedFile) {
      setError("\"".concat(unsupportedFile.name, "\" is not supported by the selected model."));
      return;
    }

    var oversizedFile = files.find(function (file) {
      return !isFileSizeWithinLimit(file.size, fileSizeLimitMb !== null && fileSizeLimitMb !== void 0 ? fileSizeLimitMb : 0);
    });

    if (oversizedFile) {
      setError("\"".concat(oversizedFile.name, "\" exceeds the ").concat(fileSizeLimitMb !== null && fileSizeLimitMb !== void 0 ? fileSizeLimitMb : 0, " MB per-file limit."));
      return;
    }

    uploadHook.addFiles(files);
  };

  var handleRemoveFile = function handleRemoveFile(fileId) {
    setError(null);
    uploadHook.removeFile(fileId);
  }; // Show loading state during validation


  var isValidating = uploadHook.isValidating || uploadHook.validatingUrl;
  useEffect(function () {
    onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange();
  }, [uploadHook.hasUploadedFiles, isValidating, uploadHook.files.length, onStateChange]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [hideUploadArea || uploadHook.hasUploadedFiles ? null : isValidating ? /*#__PURE__*/_jsxs(LoadingOverlay, {
      children: [/*#__PURE__*/_jsx(Spin, {
        size: "large"
      }), /*#__PURE__*/_jsx(LoadingText, {
        children: uploadHook.validatingUrl ? "Validating \"".concat(uploadHook.validatingUrl, "\"...") : 'Processing files...'
      })]
    }) : /*#__PURE__*/_jsx(FileDropzone, {
      onFilesSelected: handleFilesSelected,
      disabled: disabled || uploadHook.isValidating,
      multiple: !maxFileUpload || maxFileUpload > 1,
      accept: allowedFileTypes,
      helperText: fileSizeLimitMb && fileSizeLimitMb > 0 && totalSizeLimitMb && totalSizeLimitMb > 0 ? "Supported formats: ".concat((allowedFileTypes !== null && allowedFileTypes !== void 0 ? allowedFileTypes : []).join(', '), " (Max ").concat(fileSizeLimitMb, " MB/file; ").concat(totalSizeLimitMb, " MB total)") : 'File limits are unavailable for the selected model.'
    }), /*#__PURE__*/_jsx(UploadingFileList, {
      files: uploadHook.files,
      onRemove: function onRemove(file) {
        // Find the corresponding uploading file by the File object
        var uploadingFile = uploadHook.files.find(function (uf) {
          return uf.file === file;
        });

        if (uploadingFile) {
          handleRemoveFile(uploadingFile.id);
        }
      }
    }), (uploadHook.error || error) && /*#__PURE__*/_jsx(ErrorMessage, {
      children: uploadHook.error || error
    })]
  });
});
UploadFilesContainer.displayName = 'UploadFilesContainer';